import '@lottiefiles/lottie-player';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  let sawLottie = document.querySelector('#lottie-saw');
  let axesLottie = document.querySelector('#lottie-axes');
  let lottieContainer = document.querySelector('#lottie-saw-and-axe')

  if (sawLottie) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: sawLottie,
        start: "top center",
        end: "bottom top",
        onEnter: () => {
          sawLottie.setLooping(true);
          sawLottie.play();
          window.setTimeout(() => {
            sawLottie.pause();
          }, 2000)
        }
      }
    })
  }

  if (axesLottie) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: axesLottie,
        start: "top center",
        end: "bottom top",
        onEnter: () => {
          axesLottie.setLooping(false);
          axesLottie.play();
        }
      }
    })
  }

  if (lottieContainer && axesLottie && sawLottie) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: lottieContainer,
        start: "top bottom",
        end: "bottom top",
        onLeaveBack: () => {
          axesLottie.pause();
          axesLottie.seek(1);
          console.log('on leave back');
        }
      }
    })
  }
});
